export default __webpack_public_path__ + "static/media/Facturacion.76393ed6.svg";